/**
 * Remove escape sequences from a single value string.
 * Essentially just understands \n, as almost all other escaping is either unnecessary or illegal.
 * @param s Escaped (formerly quoted) parameter value string
 * @returns Unescaped string
 */
export function scanSingleValue(s, errorCallback) {
    var index = 0;
    var value = '';
    var unescapedComma = false;
    while (index < s.length) {
        if (s.charAt(index) === '\\') {
            var escaped = s.charAt(index + 1);
            if (escaped.toUpperCase() === 'N') {
                value += '\n';
            }
            else {
                value += escaped;
            }
            index += 2;
        }
        else {
            if (s.charAt(index) === ',') {
                unescapedComma = true;
            }
            value += s.charAt(index++);
        }
    }
    if (unescapedComma && errorCallback) {
        errorCallback('VALUE_UNESCAPED_COMMA');
    }
    return value;
}
/**
 * Handle escape sequences in a quoted parameter string.
 * - RFC6868 (`^^`, `^'`, and `^n`)
 * - Nag about `\n`
 * @param s Escaped (formerly quoted) parameter value string
 * @returns Unescaped string
 */
export function scanSingleParamValue(s, errorCallback) {
    var index = 0;
    var value = '';
    var warnings = new Set();
    while (index < s.length) {
        var char = s.charAt(index);
        if (char === '^') {
            var escaped = s.charAt(index + 1);
            switch (escaped) {
                case '^':
                    value += '^';
                    break;
                case "'":
                    value += '"';
                    break;
                case 'n': // RFC says U+005E only
                    value += '\n';
                    break;
                default:
                    value += '^' + escaped;
                    warnings.add('PARAM_BAD_CIRCUMFLEX');
                    break;
            }
            index += 2;
        }
        else {
            if (char === ',') {
                warnings.add('PARAM_UNESCAPED_COMMA');
            }
            else if (char === '\\') {
                warnings.add('PARAM_BAD_BACKSLASH');
            }
            value += char;
            index++;
        }
    }
    if (errorCallback) {
        warnings.forEach(errorCallback);
    }
    return value;
}
/**
 * Splits a property value at semicolons *OR* commas.
 * Observes escaped commas/semicolons, and replaces \n.
 * @param s A property's value
 * @param splitChar A semicolon or comma
 * @returns The array of unescaped strings
 */
export function scan1DValue(s, splitChar) {
    var retval = [];
    var index = 0;
    var unescaped = '';
    while (index < s.length) {
        var c = s.charAt(index);
        if (c === splitChar) {
            retval.push(unescaped);
            unescaped = '';
            index++;
        }
        else if (c === '\\') {
            var escaped = s.charAt(index + 1);
            if (escaped.toUpperCase() === 'N') {
                unescaped += '\n';
            }
            else {
                unescaped += escaped;
            }
            index += 2;
        }
        else {
            unescaped += s.charAt(index++);
        }
    }
    retval.push(unescaped);
    return retval;
}
/**
 * Splits a property value at semicolons (level 1) and the part between the semicolons at commas (level 2).
 * Observes escaped commas/semicolons, and replaces \n.
 * @param s A property's value
 * @returns 2D string array
 */
export function scan2DValue(s) {
    var retval = [];
    var currentValue = [];
    var index = 0;
    var unescaped = '';
    while (index < s.length) {
        var c = s.charAt(index);
        if (c === ';') {
            currentValue.push(unescaped);
            unescaped = '';
            retval.push(currentValue);
            currentValue = [];
            index++;
        }
        else if (c === ',') {
            currentValue.push(unescaped);
            unescaped = '';
            index++;
        }
        else if (c === '\\') {
            var escaped = s.charAt(index + 1);
            if (escaped.toUpperCase() === 'N') {
                unescaped += '\n';
            }
            else {
                unescaped += escaped;
            }
            index += 2;
        }
        else {
            unescaped += s.charAt(index++);
        }
    }
    currentValue.push(unescaped);
    retval.push(currentValue);
    return retval;
}
//# sourceMappingURL=scan.js.map